import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {PoiInsertTask} from './form/pro-tasks-form-state.service';

@Injectable()
export class ProTasksManagerStateService {

  private toggleRoutePlanerSource = new Subject<boolean>();
  private toggleRoutePlanner$ = this.toggleRoutePlanerSource.asObservable();

  private tasksManagerViewSource = new Subject<PoiInsertTask>();
  private tasksManagerView = this.tasksManagerViewSource.asObservable();

  constructor() {
  }

  public triggerRoutePlanner(data: boolean) {
    this.toggleRoutePlanerSource.next(data);
  }

  public toggleRoutePlanner(): Observable<boolean> {
    return this.toggleRoutePlanner$;
  }

  public openProTasksFormView(data: PoiInsertTask)  {
    this.tasksManagerViewSource.next(data)
  }

  public taskManagerView(): Observable<PoiInsertTask> {
    return this.tasksManagerView;
  }

}
